module.exports = __webpack_public_path__ + "assets/img/diy_active.caba6432.png";